import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Flex,
  GridItem,
  Accordion,
  AccordionIcon,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Text,
  Container,
} from '@chakra-ui/react';
import { DeptGrid } from '@rsc/ui-components/dept/design-system';

function SearchesFAQ({ block, isPDP }) {
  return (
    <Container>
      <Box py={[10, null, 20]} color="typography.light">
        <DeptGrid gap={[10, 16]}>
          <GridItem
            colSpan={[6, null, isPDP ? 12 : 8]}
            colStart={[0, null, isPDP ? 0 : 3]}
          >
            <Text as="h3" textStyle="h3" mb={[4, null, 6]}>
              {block.FAQsTitle}
            </Text>
            <Accordion allowMultiple>
              {block?.FAQsItems?.map(FAQsItem => (
                <AccordionItem key={FAQsItem._key} borderColor="stroke.base">
                  <AccordionButton
                    py={4}
                    px={0}
                    _hover={{ backgroundColor: 'initial' }}
                  >
                    <Box as="span" flex="1" textAlign="left">
                      <Text textStyle="body" fontWeight="bold">
                        {FAQsItem.question}
                      </Text>
                    </Box>
                    <Flex
                      background="primary.light"
                      borderRadius={30}
                      width={8}
                      height={8}
                      alignItems="center"
                      justifyContent="center"
                      color="primary.base"
                    >
                      <AccordionIcon />
                    </Flex>
                  </AccordionButton>
                  <AccordionPanel pb={4} px={0} pt={0}>
                    <Text textStyle="body">{FAQsItem.answer}</Text>
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </GridItem>
        </DeptGrid>
      </Box>
    </Container>
  );
}

SearchesFAQ.propTypes = {
  block: PropTypes.shape({
    FAQsTitle: PropTypes.string,
    FAQsItems: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string,
        answer: PropTypes.string,
      })
    ),
  }),
  isPDP: PropTypes.bool,
}.isRequired;

export default SearchesFAQ;
